export const showUp = {
	initial: {
		opacity: 0,
		y: 50,
	},
	animate: {
		opacity: 1,
		y: 0,
	},
}

export const showScaleUp = {
	initial: {
		opacity: 0,
		scale: 0.5,
		// y: 50,
	},
	animate: {
		opacity: 1,
		scale: 1,
		// y: 0,
	},
}
